import { timelineTrack } from '@/mocks/timeline';
import Reveal from '@/components/base/Reveal';

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full bg-background-50 px-4 py-16 md:px-8 md:py-20">
      <div className="mx-auto w-full max-w-7xl">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32">
              <span className="font-label text-[11px] tracking-[0.24em] text-primary-600">
                TIMELINE / 关键时间
              </span>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
                关键时间与最终结果，一次排好
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                {timelineTrack.summary}
              </p>

              <div className="mt-6 flex flex-wrap gap-2">
                <span className="rounded-full border border-primary-200 bg-primary-50 px-3 py-1 font-label text-[11px] text-primary-700">
                  {timelineTrack.codeLine}
                </span>
                <span className="rounded-full border border-background-300 bg-background-100 px-3 py-1 font-label text-[11px] text-foreground-600">
                  {timelineTrack.entries.length} 个节点
                </span>
                <span className="rounded-full border border-secondary-200 bg-secondary-50 px-3 py-1 font-label text-[11px] text-secondary-800">
                  共 9 天
                </span>
              </div>

              <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-5">
                <p className="font-label text-[10px] tracking-[0.2em] text-foreground-500">
                  最终结果
                </p>
                <p className="mt-2 font-heading text-base font-bold text-foreground-950">
                  {timelineTrack.finalResult.title}
                </p>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                  {timelineTrack.finalResult.text}
                </p>
                <p className="mt-3 font-label text-[11px] text-foreground-400">
                  {timelineTrack.finalResult.date} · {timelineTrack.finalResult.time} 更新
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="relative">
              <span className="absolute left-[7px] top-2 bottom-2 w-px bg-background-300 md:left-[9px]" />
              <div className="space-y-6">
                {timelineTrack.entries.map((entry, index) => (
                  <Reveal key={entry.id} delay={index * 50}>
                    <div className="relative pl-8 md:pl-10">
                      <span className="absolute left-0 top-1.5 flex h-4 w-4 items-center justify-center rounded-full border-2 border-primary-500 bg-background-50 md:h-5 md:w-5">
                        <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
                      </span>

                      <div className="rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-200 md:p-5">
                        <div className="flex flex-wrap items-center gap-3">
                          <span className="font-label text-sm font-semibold text-foreground-900">
                            {entry.date}
                          </span>
                          <span className="font-label text-xs text-foreground-400">{entry.time}</span>
                          <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-800">
                            {entry.tag}
                          </span>
                        </div>
                        <h3 className="mt-2.5 text-sm font-medium leading-relaxed text-foreground-900 md:text-[15px]">
                          {entry.title}
                        </h3>
                        <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                          {entry.detail}
                        </p>
                      </div>
                    </div>
                  </Reveal>
                ))}
              </div>

              <div className="relative mt-8 pl-8 md:pl-10">
                <span className="absolute left-0 top-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-primary-500 md:h-5 md:w-5">
                  <i className="ri-flag-2-fill text-[8px] text-background-50" />
                </span>
                <div className="rounded-lg border border-primary-300 bg-primary-50 p-5 md:p-6">
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="font-label text-sm font-semibold text-primary-800">
                      {timelineTrack.finalResult.date}
                    </span>
                    <span className="font-label text-xs text-primary-600">
                      {timelineTrack.finalResult.time}
                    </span>
                    <span className="rounded-full bg-primary-500 px-2.5 py-0.5 text-[11px] font-medium text-background-50 dark:text-foreground-950">
                      最终结果
                    </span>
                  </div>
                  <h3 className="mt-2.5 font-heading text-base font-bold text-primary-900">
                    {timelineTrack.finalResult.title}
                  </h3>
                  <p className="mt-2 text-xs leading-relaxed text-primary-800">
                    {timelineTrack.finalResult.text}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}